<template>
<div>
    <router-view/>
</div>
</template>

<script>
export default {
  name: 'Medication',
  data () {
    return {
    }
  },
}
</script>

<style lang="scss">
</style>